import { defaultShape } from '@kaiizen/kai-floor-plan';
import type { AssemblyRoom } from '@kaiizen/kai-floor-plan-editor-core';

import { flooringAreaValueNamePresenter } from '@/Client/Presenters';

import scannedLevel from './floorPlanEditorDemoProperty.json';

/**
 * The demo property: a seven-room scanned level (as scanned, before any true-up) plus an Attic
 * on level 2. Every room carries both `x` and `y`, so the floor plan view opens with nothing to save.
 */
export const DEMO_PROPERTY_ROOMS: AssemblyRoom[] = [
  ...(scannedLevel as AssemblyRoom[]),
  { id: 'attic', name: 'Attic', room: { ...defaultShape(), level: 2, x: 0, y: 0 } },
];

/** The flooring pick-list the room editor offers, mapped the way the real hosts map a group's flooring areas. */
export const DEMO_FLOOR_TYPES = ['carpetArea', 'hardwoodArea', 'tileArea', 'vinylPlankArea'].map(name => ({
  key: name,
  label: flooringAreaValueNamePresenter(name),
  id: name,
}));
